"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputNumber = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const antd_1 = require("antd");
const utils_1 = require("../controls/utils");
function InputNumber({ handleChange, path, schema, ...props }) {
    const ariaLabel = props.label || schema.description || "Value";
    const defaultValue = schema.default;
    const isDataNonNullObject = typeof props.data === "object" &&
        props.data !== undefined &&
        props.data !== null;
    const isDataEmptyObj = isDataNonNullObject
        ? Object.keys(props.data).length === 0
        : false;
    const value = props.data === undefined || isDataEmptyObj
        ? defaultValue
        : props.data;
    const numberType = schema.type;
    const isInteger = (typeof numberType === "string" && numberType === "integer") ||
        (Array.isArray(numberType) &&
            numberType.length === 1 &&
            numberType.includes("integer"));
    // TODO: Revist useCallback use - was meant to prevent re-renders
    const onChange = (0, react_1.useCallback)((value) => {
        if (typeof value === "number") {
            if (isInteger) {
                handleChange(path, (0, utils_1.coerceToInteger)(value));
            }
            else {
                handleChange(path, (0, utils_1.coerceToNumber)(value));
            }
        }
        else {
            handleChange(path, value);
        }
    }, [handleChange, isInteger, path]);
    const options = props.uischema.options;
    const addonAfter = options?.addonAfter;
    const addonBefore = options?.addonBefore;
    const isPercentage = addonAfter && typeof addonAfter === "string"
        ? addonAfter?.trim() === "%"
        : false;
    const min = schema.minimum;
    const max = schema.maximum;
    const marginLeft = min === undefined || max === undefined ? 0 : 16;
    const style = { marginLeft: marginLeft, width: "100%" };
    // TODO: Revist useCallback use - was meant to prevent re-renders
    const formatter = (0, react_1.useCallback)((value) => {
        if (value !== "" && value !== undefined) {
            if (isPercentage) {
                const valueFloat = typeof value === "string" ? parseFloat(value) : value;
                return (0, utils_1.decimalToPercentage)(valueFloat);
            }
            else {
                return value.toString();
            }
        }
        return "";
    }, [isPercentage]);
    // TODO: Revist useCallback use - was meant to prevent re-renders
    const parser = (0, react_1.useCallback)((value) => {
        const isNumeric = value ? !isNaN(Number(value)) : false;
        if (isNumeric && value !== undefined) {
            if (isPercentage) {
                return (0, utils_1.percentageStringToDecimal)(value);
            }
            else if (numberType === "integer") {
                return Math.round(parseFloat(value));
            }
            else {
                return parseFloat(value);
            }
        }
        return undefined;
    }, [isPercentage, numberType]);
    return ((0, jsx_runtime_1.jsx)(antd_1.InputNumber, { "aria-label": ariaLabel, defaultValue: defaultValue, value: value, onChange: onChange, min: min, max: max, addonBefore: addonBefore, addonAfter: addonAfter, style: style, formatter: formatter, parser: parser, controls: false }));
}
exports.InputNumber = InputNumber;
